export default __webpack_public_path__ + "static/media/pat-1.9a8e7cf8.jpg";